import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
    Dialog,
    DeleteButton
} from '../../Elements'

import { Classes } from '@blueprintjs/core'

const MultipleConfirmDeletion = (props) => {
    const {
        handleDeleteSubmit,
    } = props

    const [deletionDialogOpen, setDeletionDialogOpen] = useState(true)

    return (
        <Dialog
            icon='trash'
            title='Delete Documents?'
            isOpen={deletionDialogOpen}
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
            isCloseButtonShown={true}
            onClose={setDeletionDialogOpen}
        >
            <div className={Classes.DIALOG_BODY}>
                <p>{`Are you sure you want to delete these documents? This cannot be undone.`}</p>
                <DeleteButton onClick={handleDeleteSubmit} />
            </div>
        </Dialog>
    )
}

MultipleConfirmDeletion.propTypes = {
    handleDeleteSubmit: PropTypes.func,
}

export default MultipleConfirmDeletion
